{
  "pt": {
    "toast": {
      "action": {
        "failed": "Ocorreu um erro inesperado.",
        "impersonate_unauthorized": "Esta ação não é permitida quando se faz passar por um cliente.",
        "succeeded": "Ação bem sucedida",
        "unprocessable": "Algo correu mal. Talvez queira atualizar a página. Se o problema persistir, contacte-nos.\nERRO: {error}"
      },
      "create": {
        "failed": "Falha ao criar {itemName}",
        "succeeded": "{itemName} criado"
      },
      "delete": {
        "failed": "Falha ao eliminar {itemName}",
        "succeeded": "{itemName} foi eliminado",
        "succeeded_default": "Eliminação bem sucedida"
      },
      "update": {
        "failed": "Falha na atualização {itemName}",
        "succeeded": "{itemName} foi atualizado",
        "successfully_saved": "Guardado com sucesso"
      },
      "upload": {
        "failed": "A transferência falhou",
        "succeeded": "Carregamento bem sucedido"
      },
      "upload_document": {
        "extension_invalid": "O documento \"{document_name}\" não tem uma extensão válida."
      },
      "upload_image": {
        "file_too_big": "Ficheiro demasiado grande: o tamanho máximo do ficheiro é de 5MB"
      },
      "warning": {
        "multipleFiles": "Esta exportação contém vários ficheiros zip. Seu navegador pode bloquear vários downloads. Contacte o apoio Ziggu se tiver apenas 1 ficheiro zip descarregado."
      }
    }
  }
}
